import Navigation from '../components/Navigation';
import SEO from '../components/SEO';
import CaseStudyCard from '../components/CaseStudyCard';
import SiteFooter from '../components/SiteFooter';
import { caseStudies } from './caseStudiesData';

export default function CaseStudiesIndex() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <SEO
        title="Case studies"
        description="Greyfield Data work across Sigma reporting, Snowflake and dbt modeling, Power BI operations, customer-facing Tableau, legal analytics, and education reporting."
        url="https://www.greyfielddata.com/case-studies"
        keywords={['data engineering case studies', 'Snowflake consulting', 'dbt', 'analytics consulting']}
      />
      <Navigation />

      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pt-44 md:pb-20 bg-[#0a1628] overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:60px_60px]" />
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-bl from-blue-600/20 via-indigo-600/10 to-transparent rounded-full blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <p className="text-sm font-semibold text-blue-300 tracking-[0.2em] uppercase mb-4">Client work</p>
          <h1 className="text-4xl md:text-6xl font-semibold leading-[1.1] text-white tracking-tight mb-6">
            Case studies
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Sigma reports, Snowflake and dbt models, Power BI operations, and customer-facing Tableau tools built for specific decisions.
          </p>
        </div>
      </section>

      {/* Cards */}
      <section className="py-20 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            {caseStudies.map((study) => <CaseStudyCard key={study.slug} study={study} />)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-xl md:text-2xl font-semibold text-gray-900 tracking-tight text-center md:text-left">
            Bring the report or data workflow that needs work.
          </p>
          <a
            href="https://cal.com/linustse/meeting-with-linus"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#0a1628] text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-[#0f2d54] transition shadow-lg flex-none"
          >
            Discuss a similar project
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
